import { useUserState } from '../../../../../../ui/hooks';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { accountEntityName, getAccountPermissions, getUserOktaStatusDef, } from '../../../../../../backend/features/accounts/shared';
import { requireAnySystemPermission } from '../../../../../../backend/features/permissions/shared';
import { useAccountSlideoutMenuItems } from '../../../../../../ui/features/accounts/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { ModalSlideout, useModalSlideoutScroll } from '@juvare/common-web-ui/ModalSlideout';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useTypedPlatformFunctionResponse } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
import { useSelector } from 'react-redux';
import { AccountDetails } from '../../AccountDetails';
export const AccountSlideout = ({ accountId, hideDefaultMenuItems, onClose, customMenuItems, customDetailsComponent, accountListReload, ariaSlideoutContentId, }) => {
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const settings = useSelector(getSettings);
    const userState = useUserState();
    const { isScrolledToTop, handleScroll, handleResetScroll } = useModalSlideoutScroll();
    const handleClose = (changed) => {
        handleResetScroll();
        onClose(changed);
    };
    const { data: account, isLoading: accountIsLoading, error: accountError, mutate: accountReload, } = useStorageGet(accountEntityName, accountId);
    const loadOktaStatus = (account === null || account === void 0 ? void 0 : account.data) &&
        settings.identityProvider.oktaActionsEnabled &&
        requireAnySystemPermission(userState, 'allow-reset-okta-password-email', 'allow-reset-okta-mfa', 'allow-unlock-okta-account', 'allow-change-login-email');
    const { data: oktaStatus, isLoading: oktaStatusLoading, error: oktaStatusError, mutate: mutateOktaStatus, } = useTypedPlatformFunctionResponse(getUserOktaStatusDef, loadOktaStatus && account && accountId ? { accountId: accountId } : undefined);
    const defaultAccountMenuItems = useAccountSlideoutMenuItems({
        account,
        handleClose,
        accountListReload,
        accountReload,
        mutateOktaStatus,
        oktaStatus,
    });
    const error = accountError !== null && accountError !== void 0 ? accountError : oktaStatusError;
    const loading = oktaStatusLoading || accountIsLoading;
    if (loading || !account || !accountId) {
        return null;
    }
    const accountPermissions = getAccountPermissions(settings, userState, accountId, account.data);
    const getMenuItems = () => {
        const menuItems = [];
        if (!hideDefaultMenuItems) {
            menuItems.push(...defaultAccountMenuItems);
        }
        return customMenuItems ? customMenuItems({ account, menuItems, onClose, accountReload, accountListReload }) : menuItems;
    };
    const AccountDetailsComponent = customDetailsComponent !== null && customDetailsComponent !== void 0 ? customDetailsComponent : AccountDetails;
    return (React.createElement(ModalSlideout, { ariaContentId: ariaSlideoutContentId, open: !!accountId, onClose: () => handleClose(false), "data-test": 'account-slideout' },
        React.createElement(Box, { onScroll: handleScroll, sx: {
                overflow: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: themeColors.surface.primary,
            } },
            account && !accountError && (React.createElement(AccountDetailsComponent, { isScrolledToTop: isScrolledToTop, account: account, accountPermissions: accountPermissions, onViewProfile: () => navigationContext.navigate(() => navigate(accountId, { state: { back: true } })), menuItems: getMenuItems(), onClose: handleClose, oktaStatus: oktaStatus, reloadOktaStatus: mutateOktaStatus })),
            loading && !accountError && React.createElement(CircularProgress, null),
            !!error && React.createElement(PartialError, { error: error }))));
};
